//------------------------------------------------------------------------
// Smooth scroll jump links
//------------------------------------------------------------------------
/* jshint esversion: 6 */
/* globals window document */
import $ from "jquery";
import smoothScroll from "./smoothScroll";

class JumpLink {
  constructor(config) {
    this.$el = config.el;
    // Set scroll speed in milliseconds
    this.scrollSpeed = 800;
    this.addEventListeners();
  }

  addEventListeners() {
    this.$el.on("click", this.clickHandler);
  }

  clickHandler(evt) {
    var $target = $(evt.currentTarget);
    var shouldJump = typeof $target.attr("data-no-jump") === "undefined";
    var isSmooth = typeof $target.attr("data-not-smooth") === "undefined";

    // Prevent default on links with “data-no-jump” attribute
    if (!shouldJump) {
      return false;
    }

    // Check if link should open in a new window
    var opensNewWindow =
      $target.is('[target="_blank"]') ||
      evt.which > 1 ||
      evt.metaKey ||
      evt.ctrlKey ||
      evt.shiftKey ||
      evt.altKey;

    // Ignore links that open in a new window or that have a “data-not-smooth” attribute
    if (!opensNewWindow && shouldJump && isSmooth) {
      // Prevent default to stop page jump
      evt.preventDefault();

      var selector = $target.attr("href");

      // Check if href contains more than “#”
      if (selector === "#") {
        // Scroll to top
        smoothScroll(0, this.scrollSpeed, true);
      } else {
        // Find element to scroll to (assumes using “id” attribute, not “name”)
        var $el = $(selector);

        // Check if target element exists
        if ($el.length) {
          // Smooth scroll
          smoothScroll($el, this.scrollSpeed, true);
        } else {
          console.warn(
            "There is no element matching “" + selector + "” to scroll to"
          );
        }
      }
    } else {
      // If not using smoothScroll, we must manually shift focus to target element
      // Don't run focus code on the same element twice
      if ($target.attr("tabindex") !== "-1") {
        // Shift focus to target element
        // http://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/
        $target
          .attr("tabindex", "-1")
          .on("blur focusout", function() {
            $(this).removeAttr("tabindex");
          })
          .focus();
      }
    }
  }
}

// Query all in page links
$("body").find('a[href^="#"]').each(function() {
  new JumpLink({ el: $(this) });
});

export default JumpLink;



// WEBPACK FOOTER //
// ./app/javascript/modules/jump-links.js